import { Card, Logo, useClasses } from '@kanda-libs/ks-design-library';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import useQueryParam from 'hooks/useQueryParam';
import type { FunctionComponent } from 'react';
import FinanceInfo from './FinanceInfo';
import Footer from './Footer';
import JobForm from './JobForm';
import RateMenu from './RateMenu';
import { CLASS_NAMES } from './constants';
import useFinanceInfo from './useFinanceInfo';

export interface ContentProps {
  aprs: number[];
  rates: FinanceRate[];
  bnplRates?: FinanceRate[];
}

const Content: FunctionComponent<ContentProps> = function ({
  aprs,
  bnplRates,
  rates,
}) {
  const financeInfo = useFinanceInfo(rates, bnplRates);

  const [noBackground] = useQueryParam('noBackground');

  const classNames = useClasses(CLASS_NAMES, {
    variants: {
      background: noBackground === 'null',
    },
  });

  return (
    <div className={classNames.wrapper}>
      <div className={classNames.innerWrapper}>
        <Card className={classNames.card}>
          <Logo className={classNames.logo} />
          <RateMenu aprs={aprs} showBNPL={Boolean(bnplRates)} />
          <JobForm rates={rates} bnplRates={bnplRates} />
          <FinanceInfo financeInfo={financeInfo} />
        </Card>
        <Footer financeInfo={financeInfo} />
      </div>
    </div>
  );
};

export default Content;
